module.exports = __webpack_public_path__ + "img/jjy.74e01be6.jpeg";